import "choerodon-ui/lib/configure/style";
import _configure from "choerodon-ui/lib/configure";
import { overWriteConfig } from 'hzero-boot'; // import commonConfig from '../commonConfig';
// import { setLayout } from 'hzero-front/lib/customize/layout';
// import { setPageElement } from './pageElements';

import { setCard } from 'hzero-front/lib/customize/cards';
import cardsConfig from "./cards/customizeCards";
// import commonConfig from '@common/config/commonConfig';
// import { SizeChangerPosition } from 'choerodon-ui/pro/lib/pagination/enum';
import { addAcpInovicePageElement, addContractPageElement, addGlJournalPageElement, addReceiptAcpInvoicePageElement, addReportPageElement, addRequisitionPageElement } from "../../utils/pageElements"; // 轮播图闪屏/企业频道自定义消息素材库的秀米富文本
// import * as loadEditor from 'hippius-front/lib/components/hipsEditor/loadEditor';
// other codes
// 加载的秀米富文本
// loadEditor.load();

overWriteConfig({
  // // 全局错误处理配置
  // dealGlobalError: (error) => {
  //   window.location.href = `${commonConfig.BASE_PATH || '/'}error.html?errorMessage=${encodeURIComponent(
  //     error && error.message
  //   )}&errorLocation=${encyarnodeURIComponent(window.location.href)}`;
  // },
  // 在这个文件内可以重新 c7nUi 配置
  initC7nUiConfig: function initC7nUiConfig() {
    return require('hzero-front/lib/utils/c7nUiConfig');
  },
  // // 在 dva 对象实例化之后调用，可以在这里添加 dva 插件
  dvaAppInit: function dvaAppInit() {
    // setLayout('fins-side', async () => import('./layouts/SideLayout'));
    // require('hzero-front-hmsg/lib/customize');
    cardsConfig.forEach(setCard);
    addReportPageElement();
    addRequisitionPageElement();
    addContractPageElement();
    addAcpInovicePageElement();
    addGlJournalPageElement();
    addReceiptAcpInvoicePageElement();

    require("./global.less");

    _configure({//   pagination: {
      //     showSizeChangerLabel: false,
      //     showTotal: true,
      //     showPager: true,
      //     showQuickJumper: true,
      //     sizeChangerPosition: SizeChangerPosition.right,
      //   },
      // transport: {
      //   exports: ({ dataSet, name: fieldName }) => {
      //     const _token = dataSet?.current?.get('_token');
      //     return {
      //       url: `${commonConfig.HSSP_API}/v1/export`,
      //       method: 'POST',
      //       params: { _token, fieldName },
      //       transformResponse: (res) => {
      //         try {
      //           const aLink = document.createElement('a');
      //           const blob = new Blob([res.data], {
      //             type: 'application/vnd.ms-excel',
      //           });
      //           aLink.href = URL.createObjectURL(blob);
      //           aLink.download = fieldName;
      //           aLink.click();
      //           document.body.appendChild(aLink);
      //         } catch (e) {
      //           // do nothing, use default error deal
      //         }
      //       },
      //     };
      //   },
      // },
    });
  } // // 可以设置 dvaApp.router 的根路由
  // dvaRootRouter: () => require('hzero-front/lib/router').default,
  // // 可以替换 global 配置
  // globalModal: () => require('./models/global').default,

});